import "booking_app/directives/accordion.js";
import { AppSettings } from "booking_app/values/app-settings";

export class TaxAndFeesAccordionController {
  static $inject = ["$scope", "AppSettings"];

  hotelPrice: any;
  currencyCode: string;
  displayCurrencySymbol: boolean;

  constructor(
    private $scope: any,
    private appSettings: AppSettings,
  ) {
    this.$scope = $scope;
    this.displayCurrencySymbol = this.appSettings.defaultCurrencyDisplay === "symbol";
  }

  public renderAccordion(): boolean {
    return this.hotelPrice.formattedIncludedTaxesAndFees.length > 1;
  }

  $onChanges(changes: any): void {
    if (changes.hotelPrice) {
      this.$scope.$broadcast("accordionDataUpdated");
    }
  }
}
